"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RouterPromptModal = void 0;
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var layout_1 = require("../layout");
var RouterPromptModal = function (props) {
    var blocker = (0, react_router_dom_1.useBlocker)(props.block);
    return (react_1.default.createElement(layout_1.Modal, { id: "unsaved-changes-prompt", title: "Are you sure you want to leave the page?", open: blocker.state == 'blocked', onClose: function () { }, onOpened: function () { }, leftButtons: [
            {
                label: 'OK',
                mode: 'secondary',
                onClick: function () { return blocker.proceed && blocker.proceed(); },
            },
        ], rightButtons: [
            {
                label: 'Cancel',
                mode: 'secondary',
                onClick: function () { return blocker.reset && blocker.reset(); },
            },
        ] },
        react_1.default.createElement("span", null, "Changes you have made to the form will not be saved. Please save your changes before moving away from this page.")));
};
exports.RouterPromptModal = RouterPromptModal;
//# sourceMappingURL=RouterPromptModal.js.map